import React from 'react';
import Link from 'next/link';
import { CATEGORIES } from '@/data/marketData';

interface CategoryQuickLinksProps {
  lang: 'en' | 'ta';
}

export default function CategoryQuickLinks({ lang }: CategoryQuickLinksProps) {
  return (
    <section>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-foreground">
          {lang === 'en' ? 'Browse by Category' : 'வகையின்படி உலாவு'}
        </h2>
        <Link href="/product-category-browse" className="text-sm text-primary font-semibold hover:underline">
          {lang === 'en' ? 'View all →' : 'அனைத்தும் →'}
        </Link>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-3">
        {CATEGORIES.filter(c => c.id !== 'all').map(cat => (
          <Link
            key={`cat-link-${cat.id}`}
            href={`/product-category-browse?category=${cat.id}`}
            className="card-base card-hover p-4 flex flex-col items-center gap-2 text-center group"
          >
            <span className="text-3xl group-hover:scale-110 transition-transform duration-200">{cat.icon}</span>
            <p className="text-xs font-semibold text-foreground">
              {lang === 'en' ? cat.name : cat.nameTa}
            </p>
            <p className="text-xs text-muted-foreground">{cat.count} items</p>
          </Link>
        ))}
      </div>
    </section>
  );
}